<template>
  <BfAccordion :title="t('setup.parts.pedals')">
    <template #header-right>
      <BfButton
        :type="ButtonType.Outlined"
        @click.stop="
          router.push({
            name:
              router.currentRoute.value.meta.step === 2
                ? 'pedalSelection'
                : 'pedalUpdate',
          })
        "
      >
        {{ t('common.change') }}
      </BfButton>
      <BfBadge
        :color="
          selectedMeasurement?.pedal.active !== undefined
            ? Colors.Success
            : Colors.Danger
        "
      />
    </template>
    <BfDescriptionList :label="t('setup.pedal.model')">
      {{
        selectedMeasurement?.pedal.active
          ? `${selectedMeasurement?.pedal.active.PEDAL_BRAND} ${selectedMeasurement?.pedal.active.PEDAL_MODEL}`
          : '-'
      }}
    </BfDescriptionList>
    <BfDescriptionList :label="t('setup.pedal.stack')">
      {{
        selectedMeasurement?.pedal.active
          ? `${selectedMeasurement?.pedal.active.PEDAL_HEIGHT} ${t('common.unit.mm')}`
          : '-'
      }}
    </BfDescriptionList>
  </BfAccordion>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useMeasurementStore } from '@/store/measurementStore'
import {
  Colors,
  ButtonType,
  BfBadge,
  BfAccordion,
  BfButton,
  BfDescriptionList,
} from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const router = useRouter()
const measurementStore = useMeasurementStore()
const { selectedMeasurement } = storeToRefs(measurementStore)
</script>

<style lang="scss"></style>
